export const contracts = {
  Contracts: 'Contratos',
  Sign: 'Firmar',
  'Sign them to schedule your sessions as soon as possible':
    '¡Firmalos para poder agendar tus sesiones lo antes posible!',
  'You have contracts to sign': 'Tenés contratos para firmar',
  "You will be redirected automatically as soon as you sign the contracts If this doesn't happen, click here":
    'Vas a ser redirigido automáticamente apenas firmes los contratos. Si eso no pasa, hacé clic acá',
};
